// general settings
import * as THREE from "three";

let gamePlaying = false;
const gravity = .5;
const speed = 4.2;
const size = [51, 36];
const jump = -9.5;

const scale = 1
// need pow of two for textures
const nextPowOfTwo = val =>{
    return Math.pow(2, Math.floor(Math.log(val)/Math.log(2)));
}
const canvasHeight = nextPowOfTwo(768 * scale);
const canvasWidth = nextPowOfTwo(canvasHeight*5);

const imageMap = {
    pipeX: 432,
    pipeY: 108,
    pipeHeight: 480,
    backgroundWidth: 431,
    backgroundHeight: 768
}


let cTenth, canvas, ctx, img;

let index = 0,
    bestScore = 0,
    flight,
    flyHeight,
    currentScore,
    pipes,
    pipeLoc,
    canvasTexture;

// pipe settings
const pipeWidth = 78 * scale;
const pipeGap = 270 * scale;

export const setupFlappyBird = (renderCallback) => {

    if(!canvas){

        if(window.flabbyBirdCanvas){
            canvas = window.flabbyBirdCanvas;
        }
        else{
            canvas = window.flabbyBirdCanvas = document.createElement( 'canvas' );
        }

        // document.body.prepend(canvas);  //todo

        canvas.width = canvasWidth;
        canvas.height = canvasHeight;

        ctx = canvas.getContext('2d');
        img = new Image();
        img.src = "/bird/flappy-bird-set.png";
        img.onload = () => render(renderCallback);
        cTenth = (canvas.width / 6);

        document.addEventListener('keyup', event => {
            if (event.code === 'Space') {
                flight = jump;
            }
        })

        canvasTexture= new THREE.CanvasTexture(canvas);
        reset();
    }

    return canvasTexture
}

export function jumpFlappy(){
    flight = jump;
}

const reset = () => {
    pipeLoc = () => (Math.random() * ((canvas.height - (pipeGap + pipeWidth)) - pipeWidth)) + pipeWidth;

    currentScore = 0;
    flight = jump;

    // set initial flyHeight (middle of screen - size of the bird)
    flyHeight = (canvas.height / 2) - (size[1] / 2);

    // setup first 3 pipes
    pipes = Array(10).fill().map((a, i) => [canvas.width + (i * (pipeGap + pipeWidth)), pipeLoc(), 0]);
}

let countDownUntilReplay = 0

const render = (renderCallback) => {
    // make the pipe and bird moving
    index++;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // background first part
    ctx.drawImage(img, 0, 0, imageMap.backgroundWidth, imageMap.backgroundHeight, -((index * (speed / 2)) % canvas.width) + canvas.width, 0, canvas.width, canvas.height);
    // background second part
    ctx.drawImage(img, 0, 0, imageMap.backgroundWidth, imageMap.backgroundHeight, -(index * (speed / 2)) % canvas.width, 0, canvas.width, canvas.height);

    // pipe display
    if (gamePlaying){
        pipes.map(pipe => {
            // pipe moving
            pipe[0] -= speed;

            // top pipe
            ctx.drawImage(img, imageMap.pipeX, imageMap.pipeY + imageMap.pipeHeight - pipe[1], pipeWidth, pipe[1], pipe[0], 0, pipeWidth, pipe[1]);
            // bottom pipe
            ctx.drawImage(img, imageMap.pipeX + pipeWidth, imageMap.pipeY, pipeWidth, canvas.height - pipe[1] + pipeGap, pipe[0], pipe[1] + pipeGap, pipeWidth, canvas.height - pipe[1] + pipeGap);

            // give 1 point
            if(pipe[0] <= cTenth-pipeWidth && pipe[2] === 0){
                currentScore++;
                pipe[2] = 1;
                bestScore = Math.max(bestScore, currentScore);
            }
            // remove & create new pipe
            if(pipe[0] <= -pipeWidth){
                pipes = [...pipes.slice(1), [pipes[pipes.length-1][0] + pipeGap + pipeWidth, pipeLoc()]];
            }

            // if hit the pipe, end
            if ([
                pipe[0] <= cTenth + size[0],
                pipe[0] + pipeWidth >= cTenth,
                pipe[1] > flyHeight || pipe[1] + pipeGap < flyHeight + size[1]
            ].every(elem => elem)) {
                gamePlaying = false;
                countDownUntilReplay = (new Date()).getTime() + 3000
                // reset()
            }
        })
    }
    // draw bird
    if (gamePlaying) {
        ctx.drawImage(img, imageMap.pipeX, Math.floor((index % 9) / 3) * size[1], ...size, cTenth, flyHeight, ...size);
        flight += gravity;
        flyHeight = Math.min(flyHeight + flight, canvas.height - size[1]);
    } else {
        ctx.drawImage(img, imageMap.pipeX, Math.floor((index % 9) / 3) * size[1], ...size, ((canvas.width / 2) - size[0] / 2), flyHeight, ...size);
        flyHeight = (canvas.height / 2) - (size[1] / 2);
        // text accueil
        ctx.fillText(`Score: ${currentScore}`, 85, 210);
        ctx.fillText(`Best: ${bestScore}`, 85, 245);
        // ctx.fillText('Click to play', 90, 535);
        ctx.font = "bold 30px courier";

        const now = new Date().getTime()
        if(countDownUntilReplay){
            if(now < countDownUntilReplay){
                const diff = Math.round((countDownUntilReplay - now) / 1000)
                ctx.fillText(`Restart in ${diff}`, 90, 535);
            }
            else{
                countDownUntilReplay = null;
                reset();
                startGame()
            }
        }
    }

    // document.getElementById('bestScore').innerHTML = `Best : ${bestScore}`;
    // document.getElementById('currentScore').innerHTML = `Current : ${currentScore}`;

    if(renderCallback){
        renderCallback();
    }

    // tell the browser to perform anim
    window.requestAnimationFrame(()=>render(renderCallback));
}


export function createPlane(renderCallback){
    const geometry = new THREE.PlaneGeometry( canvasWidth, canvasHeight );
    const material = new THREE.MeshBasicMaterial( {
        map: setupFlappyBird(renderCallback),
        side: THREE.DoubleSide
    });
    const plane = new THREE.Mesh( geometry, material );
    return plane;
}

export function createBackgroundPlane(width, height, isSky){
    const color = isSky ? '#4EC0CA' : '#5EE270'
    const geometry = new THREE.PlaneGeometry(width, height );
    const material = new THREE.MeshBasicMaterial( {color});
    return new THREE.Mesh(geometry, material);
}


export function startGame(){
    gamePlaying = true
}
